import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('tooltip', {
    mounted(el, binding) {
      tippy(el, {
        content: binding.value,
        placement: 'top',
        arrow: true,
        delay: [100, 0],
        theme: 'light-border',
      })
    },
    unmounted(el) {
      const instance = (el as any)._tippy
      if (instance) {
        instance.destroy()
      }
    },
    getSSRProps(binding, vnode) {
      return {}
    },
  })
})
